import {getMasterModuleService} from '../features/modules/services'

export const useBooking = () => {
  const getTypeBookingNotes = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 200,
        tableName: 'TipoNota',
      })
      const data = response.data.data
      const mappedMaster = data?.map((master) => ({
        value: master.id,
        label: master.nombreCorto,
      }))
      return mappedMaster
    } catch (error) {
      console.log(error)
      return []
    }
  }

  return {
    getTypeBookingNotes,
  }
}
